<template>
	<Layout>
		<div class="directory-container">
			<div class="container">
				<div class="navbar-group justify-space-between flex-wrap gap-2">
					<div><TrialModal /></div>
					<div><NewSchoolModal /></div>

					<div style="flex-grow: 1; max-width: 100%; position: relative">
						<v-text-field
							style="width: 350px; max-width: 100%; margin-left: auto"
							class="custom-input"
							label="Search Directory"
							variant="outlined"
							bg-color="white"
							color="gray300"
							density="comfortable"
							v-model="state.search"
							append-inner-icon="mdi-magnify"
							clearable
						>
							<template #append>
								<v-menu
									location="bottom right"
									@update:model-value="state.showSelectionMenu = $event"
								>
									<template #activator="{ props }">
										<v-icon v-bind="props">mdi-menu-down</v-icon>
									</template>
									<v-list>
										<v-list-item
											active-color="primary"
											:active="state.deleted == false"
											:value="false"
											@click="state.deleted = false"
											>Active Records</v-list-item
										>
										<v-list-item
											active-color="primary"
											:active="state.deleted == true"
											:value="true"
											@click="state.deleted = true"
											>Archived Records</v-list-item
										>
									</v-list>
								</v-menu>
							</template>
						</v-text-field>
					</div>
				</div>
				<AccountsDirectory
					:deleted="state.deleted"
					:search="state.search || ''"
					@update:search="state.search = $event"
				/>
			</div>
		</div>
	</Layout>
</template>

<script setup lang="ts">
import Layout from "@/views/support/Layout.vue";
import AccountsDirectory from "@/components/support/AccountsDirectory.vue";
import { reactive } from "vue";
import TrialModal from "@/components/support/TrialModal.vue";
import NewSchoolModal from "@/components/support/NewSchoolModal.vue";

const state = reactive({
	search: "",
	showSelectionMenu: false,
	deleted: false,
});
//
</script>

<style scoped lang="scss">
.directory-container {
	padding: 20px 30px 0;
}
</style>
